import type { PrintJobCreateView, PrintJobStatusView } from "@fiket/booth-schema";

interface ApiOk<T> {
  success: true;
  data: T;
}
interface ApiFail {
  success: false;
  error: { code: string; message: string };
}

/** 서버 봉투의 error.code(`PRINT_MODE_MISMATCH`·`IMAGE_NOT_READY`·`NOT_FOUND`) 또는 봉투가 아니면 `HTTP_ERROR` */
export class PrintApiError extends Error {
  readonly code: string;
  readonly httpStatus: number;
  constructor(code: string, message: string, httpStatus: number) {
    super(message);
    this.name = "PrintApiError";
    this.code = code;
    this.httpStatus = httpStatus;
  }
}

async function unwrap<T>(res: Response): Promise<T> {
  const body = (await res.json().catch(() => null)) as ApiOk<T> | ApiFail | null;
  if (!body || !body.success) {
    const code = body && !body.success ? body.error.code : "HTTP_ERROR";
    const message = body && !body.success ? body.error.message : `HTTP ${res.status}`;
    throw new PrintApiError(code, message, res.status);
  }
  return body.data;
}

/** POST /api/sessions/:shortCode/print — 서버 인쇄 큐에 작업 생성 (agent 모드 부스만, 세션 ready 필요) */
export async function createPrintJob(shortCode: string, signal?: AbortSignal): Promise<PrintJobCreateView> {
  const res = await fetch(`/api/sessions/${encodeURIComponent(shortCode)}/print`, { method: "POST", signal });
  return unwrap<PrintJobCreateView>(res);
}

/** GET /api/print-jobs/:printId — 폴링. 서버가 no-store 지만 클라이언트도 캐시를 쓰지 않는다 */
export async function fetchPrintJob(printId: string, signal?: AbortSignal): Promise<PrintJobStatusView> {
  const res = await fetch(`/api/print-jobs/${encodeURIComponent(printId)}`, { cache: "no-store", signal });
  return unwrap<PrintJobStatusView>(res);
}
